<template>
    <div :class="['insert-rec','insert-shop-card',expiredClass]">  
        <a :href="fields.linkUrl" class="insert-box sendAction padding-zero" data-spm-data="p" :data-spm-content="dataSpmContent" target="_blank" data-acode = "8886">
            <div class="external-poster">
                <template v-if="cardInfo.pluginType==35">
                    <div class="text-detail border-bottom-zero">
                        <h5 class="title">{{title}}</h5>
                        <div class="content" v-if="desc">
                            {{desc}}
                        </div>
                        <div class="insert-btn-fix fix-position" v-if="fields.btnText">{{fields.btnText}}</div>
                    </div>
                    <img :src="image" alt="配图" class="cover" ref="imgref">
                </template>
                <template v-else>
                    <img :src="image" alt="配图" class="cover">
                    <div class="text-detail border-top-zero">
                        <h5 class="title">{{title}}</h5>
                        <div class="content" v-if="desc">
                            {{desc}}
                        </div>
                        <div class="insert-btn-fix fix-position" v-if="fields.btnText">{{fields.btnText}}</div>
                    </div>
                </template>
                
            </div>
        </a>
        <div class="rec" v-if="cardInfo.accountName&&cardInfo.avatar">
            <div class="rec-avator"><img :src="cardInfo.avatar"/></div>
            <div class="rec-text">{{cardInfo.accountName}}推荐</div>
            <div class="rec-expired-tag" v-if="status === 4 || status === 3">已失效</div>
        </div>
    </div>
</template>

<script>
import { setPicSize } from "../../../utils/pic-util.js"

export default {
	name: "external-poster",
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    computed: {
        fields() {
            return this.cardInfo?.fields || {}
        },
        title() {
            return this.fields?.title?.substring(0,26) || ''
        },
        desc() {
            return this.fields?.desc?.substring(0,26) || ''
        },
        image() {
            return setPicSize(this.fields?.image, 1060, undefined, 'c_zoom')
        },
        dataSpmContent() {
            return '||' + this.cardInfo?.uuid + '|||'
        },
        status() {
            return this.cardInfo?.status || 1
        },
        expiredClass() {
            return this.status === 4 || this.status === 3 ? 'expired' : ''
        }
    },
}
</script>

<style lang="less" scoped>

</style>